import * as React from 'react';
import { GridLayout, SelectableCard, P, Span } from '@salecycle/ui-component-library';
import {
  useNewOffsiteCampaignState,
  useNewOffsiteCampaignDispatch,
} from '../../../context/UseNewOffsiteCampaignContext';
import { useFeatureFlags } from 'core/app/AppContext';
import { updateStepValidityAction } from '../../../actions';
import { useTranslation } from 'react-i18next';
import { IOffsiteCampaignType } from 'sections/offsite-campaigns/entities/offsiteCampaign';

export interface IProps {
  currentStep: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const FeaturesStep: React.FC<IProps> = ({ currentStep }: IProps) => {
  const { t } = useTranslation('campaigns');
  const dispatch = useNewOffsiteCampaignDispatch();
  const { validSteps } = useNewOffsiteCampaignState();
  const { flagEnabled } = useFeatureFlags();

  const Sidebar = (
    <P bold={true}>
      Objective:
      <Span>{t('campaigns:objectives.recoverAbandonedSales.title')}</Span>
    </P>
  );

  const [selected, setSelected] = React.useState('cartAbandonment');

  React.useEffect(() => {
    dispatch({
      type: 'SET_SELECTED_FEATURE_VALUE',
      payload: { type: selected },
    });
  }, [selected]);

  const handleTypeSelect = (type: IOffsiteCampaignType) => () => {
    setSelected(type);
  };

  React.useEffect(() => {
    updateStepValidityAction(true, validSteps, currentStep, dispatch);
  }, []);

  return (
    <GridLayout
      heading={t('newCampaigns.features.heading')}
      childWidth={250}
      showSidebar={true}
      sidebar={Sidebar}
      sidebarHeading={t('newCampaigns.sidebar.heading')}
    >
      <SelectableCard
        key={`typePanel-cartAbandonment`}
        heading={t('campaigns:offsite.cartAbandonment.title')}
        icon={'cart-arrow-down'}
        description={t('campaigns:offsite.cartAbandonment.description')}
        isSelected={selected === 'cartAbandonment'}
        onClick={handleTypeSelect('cartAbandonment')}
      />
      {flagEnabled('browse-abandonment-rule') && (
        <SelectableCard
          key={`typePanel-browseAbandonment`}
          heading={t('campaigns:offsite.browseAbandonment.title')}
          icon={'eye'}
          description={t('campaigns:offsite.browseAbandonment.description')}
          isSelected={selected === 'browseAbandonment'}
          onClick={handleTypeSelect('browseAbandonment')}
        />
      )}
    </GridLayout>
  );
};
